import React from 'react'
import ReactSearchBar from '../lib/SearchBar'
import * as StyledComponent from '../styles'
import I18n from '../lib/i18n'

const SearchBar = (props, context) => {
  return <StyledComponent.SearchBar className={props.className} border={props.border}>
    <ReactSearchBar
      type='search'
      name='search'
      value={props.value}
      onChange={props.onChange}
      onSearch={props.onSearch}
      onClear={props.onClear}
      renderClearButton
      suggestions={[]}
      placeholder={props.placeholder || I18n.t('searchbar.placeholder')}
    />
    <div className='cancel-btn' onClick={props.onCancel}>
      { I18n.t('searchbar.cancel') }
    </div>
  </StyledComponent.SearchBar>
}

export default SearchBar



// WEBPACK FOOTER //
// ./src/components/SearchBar.js